export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20background%20with%20soft%20flowing%20gradients%20in%20warm%20earthy%20tones%2C%20minimalist%20geometric%20patterns%2C%20clean%20digital%20aesthetic%2C%20subtle%20glass%20morphism%20elements%2C%20light%20airy%20atmosphere%2C%20contemporary%20tech%20branding%20style%2C%20bright%20neutral%20palette&width=1800&height=1200&seq=hero-bg-91browser&orientation=landscape"
          alt="91网页浏览器界面背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/15 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-sm font-medium text-background-50">v4.2 全新发布</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
            极速安全
            <span className="block mt-2">畅享无忧上网体验</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            91网页浏览器 —— 采用自研Velo渲染引擎，为您带来秒开网页的极速体验。
            内置智能广告拦截与多层隐私防护，让每一次浏览都安心流畅。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
            >
              <i className="ri-download-2-line w-5 h-5 flex items-center justify-center"></i>
              立即下载
            </a>
            <a
              href="#features"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-lg text-base font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-all duration-200"
            >
              了解更多
              <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8 text-background-50/60">
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-background-50">5000万+</div>
              <div className="text-xs mt-1">全球用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-background-50">4.8</div>
              <div className="text-xs mt-1">用户评分</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-background-50">200+</div>
              <div className="text-xs mt-1">覆盖国家</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}